import React from "react";
import styled from "@emotion/styled";

const ProfileCard = ({
  name,
  description,
  imageUrl,
  linkedinUrl,
  className,
}) => {
  return (
    <CardWrapper className={className}>
      <ContentWrapper>
        <CardContent>
          <Header>
            <Name>{name}</Name>
            <LinkedinLink
              href={linkedinUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn Profile"
            >
              <svg
                width="21"
                height="22"
                viewBox="0 0 21 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.5 0.5C20.2969 0.5 21 1.20312 21 2.04688V20C21 20.8438 20.2969 21.5 19.5 21.5H1.45312C0.65625 21.5 0 20.8438 0 20V2.04688C0 1.20312 0.65625 0.5 1.45312 0.5H19.5ZM6.32812 18.5V8.51562H3.23438V18.5H6.32812ZM4.78125 7.10938C5.76562 7.10938 6.5625 6.3125 6.5625 5.32812C6.5625 4.34375 5.76562 3.5 4.78125 3.5C3.75 3.5 2.95312 4.34375 2.95312 5.32812C2.95312 6.3125 3.75 7.10938 4.78125 7.10938ZM18 18.5V13.0156C18 10.3438 17.3906 8.23438 14.25 8.23438C12.75 8.23438 11.7188 9.07812 11.2969 9.875H11.25V8.51562H8.29688V18.5H11.3906V13.5781C11.3906 12.2656 11.625 11 13.2656 11C14.8594 11 14.8594 12.5 14.8594 13.625V18.5H18Z"
                  fill="#212543"
                />
              </svg>
            </LinkedinLink>
          </Header>
          <Description>{description}</Description>
        </CardContent>
      </ContentWrapper>
      <ProfileImageContainer>
        <ProfileImageBorder>
          <ProfileImage style={{ backgroundImage: `url(${imageUrl})` }} />
        </ProfileImageBorder>
      </ProfileImageContainer>
    </CardWrapper>
  );
};

const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 366px;
  padding: 56px 0px 0px;
  box-sizing: border-box;
  position: relative;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  border-radius: 32px;
  background: white;
  padding: 8px;
`;

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
  border: 2px solid rgba(136, 136, 136, 0.1);
  border-radius: 32px;
  background: white;
  padding: 48px 16px 16px;
  box-sizing: border-box;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

const Name = styled.h2`
  color: rgb(33, 37, 67);
  font-size: 20px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  line-height: 160%;
  margin: 0;
  flex: 1;
`;

const LinkedinLink = styled.a`
  color: rgb(33, 37, 67);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }
`;

const Description = styled.p`
  color: rgb(33, 37, 67);
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  margin: 0;
  width: 100%;
`;

const ProfileImageContainer = styled.div`
  display: flex;
  border: 2px solid rgba(136, 136, 136, 0.1);
  border-radius: 999px;
  position: absolute;
  top: 0;
  left: 10%;
  transform: translateX(-10%);
`;

const ProfileImageBorder = styled.div`
  display: flex;
  border: 4px solid white;
  border-radius: 999px;
`;

const ProfileImage = styled.div`
  width: 100px;
  height: 100px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 999px;
`;

export default ProfileCard;
